import { useState } from "react";
import { hotTopics, topicTags } from "@/mocks/home";

export default function HotTopicWall() {
  const [activeTag, setActiveTag] = useState("all");

  const visibleTopics =
    activeTag === "all" ? hotTopics : hotTopics.filter((t) => t.category === activeTag);

  return (
    <section id="topics" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
              <i className="ri-hashtag" />
              Topic Wall
            </span>
            <h2 className="mt-3 font-heading font-black text-3xl md:text-4xl text-foreground-950">
              今日热点话题墙
            </h2>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              按话题挑着看，比一条条翻更省事。这里把当下被讨论得最多的几个方向排在了一起，
              标题优先，配图点到为止。
            </p>
          </div>
          <a
            href="#feed"
            className="inline-flex items-center gap-2 text-sm font-label text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            看全部爆料速览
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-7">
          {topicTags.map((tag) => {
            const active = activeTag === tag.id;
            return (
              <button
                key={tag.id}
                type="button"
                onClick={() => setActiveTag(tag.id)}
                className={`px-4 py-2 rounded-full text-sm font-label font-medium transition-colors whitespace-nowrap ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {tag.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {visibleTopics.map((topic) => (
            <article
              key={topic.id}
              className="group flex items-stretch gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex flex-col items-center justify-start shrink-0 pt-0.5">
                <span className="font-heading font-black text-2xl text-primary-500 leading-none">
                  {topic.rank}
                </span>
                <span className="mt-2 w-px flex-1 bg-background-200" />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs font-label font-medium">
                    {topic.tag}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-label">
                    <i className="ri-fire-line" />
                    {topic.heat}
                  </span>
                </div>
                <h3 className="mt-3 font-heading font-bold text-lg md:text-xl text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {topic.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500 font-label">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />
                    {topic.time}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    展开话题
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>

              <div className="hidden sm:block w-28 md:w-32 shrink-0 rounded-md overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  title={`${topic.title} 黑料入口话题`}
                  className="w-full h-full min-h-[92px] object-cover object-top"
                />
              </div>
            </article>
          ))}
        </div>

        {visibleTopics.length === 0 && (
          <div className="py-14 text-center rounded-lg bg-background-50 border border-dashed border-background-300">
            <i className="ri-inbox-archive-line text-3xl text-foreground-400" />
            <p className="mt-3 text-sm text-foreground-500">这个话题暂时没有新动态，换个标签看看。</p>
          </div>
        )}
      </div>
    </section>
  );
}